// ToastManager.js
import React, { useState, createContext, useContext, useCallback } from 'react';
import ToastMessage from 'app/components/ToastMessage';

const ToastContext = createContext(null);

export const ToastProvider = ({ children }) => {
  const [toast, setToast] = useState({ show: false, message: '', type: 'success', action: null });

  // `action` is optional and additive — existing callers passing no third
  // argument are unaffected. Shape: { label, onClick }.
  const showToast = useCallback((message, type = 'success', action = null) => {
    setToast({ show: true, message, type, action });
  }, []);

  const hideToast = useCallback(() => setToast({ ...toast, show: false }), [toast]);

  return (
    <ToastContext.Provider value={showToast}>
      {children}
      <div style={{ position: 'fixed', top: 20, right: 20, zIndex: 9999 }}>
        <ToastMessage
          message={toast.message}
          type={toast.type}
          show={toast.show}
          onClose={hideToast}
          action={toast.action}
        />
      </div>
    </ToastContext.Provider>
  );
};

export const useToast = () => useContext(ToastContext);
